import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import { useUser } from './Context/UserContext';

/**
 * Protege uma rota com base nas permissões do módulo/item.
 * perm = [moduleKey, itemKey]  — se ausente, a rota é acessível a qualquer usuário autenticado.
 * Redireciona para "/" se o usuário não tiver permissão.
 */
const PermissionRoute = ({ children, perm, allowedRoles = [] }) => {
  const { can } = usePermissions();
  const { user } = useUser();
  if (perm && !can(perm[0], perm[1]) && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default PermissionRoute;
